import { useCallback } from 'react';
import { useIntl, type MessageDescriptor } from 'react-intl';
import { AiChatMessageSender, type AiChatSystemType } from '@shipstation/aiui';

import { messages } from '../messages';
import type { ShippyMessage } from '../shippy-persistence';

type SystemMessageKey = 'transfer' | 'agentConnected' | 'sessionEnded';

const systemMessageConfig: Record<SystemMessageKey, { message: MessageDescriptor; systemType: AiChatSystemType }> = {
  transfer: { message: messages.transferMessage, systemType: 'connecting' },
  agentConnected: { message: messages.agentConnectedMessage, systemType: 'agent-connected' },
  sessionEnded: { message: messages.sessionEndedMessage, systemType: 'session-ended' },
};

/**
 * Hook providing helper functions for Sierra chat operations.
 */
export const useSierraHelpers = () => {
  const intl = useIntl();

  /**
   * Create a system message (transfer, agent connected, session ended, etc.)
   * @param key - The type of system message to create
   */
  const createSystemMessage = useCallback(
    (key: SystemMessageKey): ShippyMessage => {
      const config = systemMessageConfig[key];
      return {
        id: crypto.randomUUID(),
        content: intl.formatMessage(config.message),
        sender: AiChatMessageSender.SYSTEM,
        systemType: config.systemType,
        timestamp: new Date(),
      };
    },
    [intl],
  );

  return { createSystemMessage };
};
